var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 0.666992H1.33268C0.964492 0.666992 0.666016 0.965469 0.666016 1.33366V6.00033C0.666016 6.36852 0.964492 6.66699 1.33268 6.66699H5.99935C6.36754 6.66699 6.66602 6.36852 6.66602 6.00033V1.33366C6.66602 0.965469 6.36754 0.666992 5.99935 0.666992Z",
    fill: "#5C5D6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 0.666992H9.9987C9.63051 0.666992 9.33203 0.965469 9.33203 1.33366V6.00033C9.33203 6.36852 9.63051 6.66699 9.9987 6.66699H14.6654C15.0336 6.66699 15.332 6.36852 15.332 6.00033V1.33366C15.332 0.965469 15.0336 0.666992 14.6654 0.666992Z",
    fill: "#5C5D6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 9.33398H1.33268C0.964492 9.33398 0.666016 9.63246 0.666016 10.0007V14.6673C0.666016 15.0355 0.964492 15.334 1.33268 15.334H5.99935C6.36754 15.334 6.66602 15.0355 6.66602 14.6673V10.0007C6.66602 9.63246 6.36754 9.33398 5.99935 9.33398Z",
    fill: "#5C5D6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 9.33398H9.9987C9.63051 9.33398 9.33203 9.63246 9.33203 10.0007V14.6673C9.33203 15.0355 9.63051 15.334 9.9987 15.334H14.6654C15.0336 15.334 15.332 15.0355 15.332 14.6673V10.0007C15.332 9.63246 15.0336 9.33398 14.6654 9.33398Z",
    fill: "#5C5D6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.ce383cb7abe6b3c8128d7a3cd4c5e114.svg";
export { ForwardRef as ReactComponent };